var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Counter: "+_vm._s(_vm.counter))]),_c('button',{on:{"click":_vm.decrement}},[_vm._v("Decrement")]),_c('button',{on:{"click":_vm.increment}},[_vm._v("Increment")])])}
var staticRenderFns = []

export { render, staticRenderFns }